import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\SupplierOrder\GetSupplierOrderAvailableItemsController::__invoke
* @see app/Http/Controllers/SupplierOrder/GetSupplierOrderAvailableItemsController.php
* @route '/api/supplier-order/{supplier_order}/items'
*/
const GetSupplierOrderAvailableItemsController = (args: { supplier_order: string | number | { id: string | number } } | [supplier_order: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetSupplierOrderAvailableItemsController.url(args, options),
    method: 'get',
})

GetSupplierOrderAvailableItemsController.definition = {
    methods: ["get","head"],
    url: '/api/supplier-order/{supplier_order}/items',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\SupplierOrder\GetSupplierOrderAvailableItemsController::__invoke
* @see app/Http/Controllers/SupplierOrder/GetSupplierOrderAvailableItemsController.php
* @route '/api/supplier-order/{supplier_order}/items'
*/
GetSupplierOrderAvailableItemsController.url = (args: { supplier_order: string | number | { id: string | number } } | [supplier_order: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { supplier_order: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { supplier_order: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            supplier_order: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        supplier_order: typeof args.supplier_order === 'object'
        ? args.supplier_order.id
        : args.supplier_order,
    }

    return GetSupplierOrderAvailableItemsController.definition.url
            .replace('{supplier_order}', parsedArgs.supplier_order.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\SupplierOrder\GetSupplierOrderAvailableItemsController::__invoke
* @see app/Http/Controllers/SupplierOrder/GetSupplierOrderAvailableItemsController.php
* @route '/api/supplier-order/{supplier_order}/items'
*/
GetSupplierOrderAvailableItemsController.get = (args: { supplier_order: string | number | { id: string | number } } | [supplier_order: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetSupplierOrderAvailableItemsController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SupplierOrder\GetSupplierOrderAvailableItemsController::__invoke
* @see app/Http/Controllers/SupplierOrder/GetSupplierOrderAvailableItemsController.php
* @route '/api/supplier-order/{supplier_order}/items'
*/
GetSupplierOrderAvailableItemsController.head = (args: { supplier_order: string | number | { id: string | number } } | [supplier_order: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetSupplierOrderAvailableItemsController.url(args, options),
    method: 'head',
})

export default GetSupplierOrderAvailableItemsController